import { createTheme } from '@mui/material/styles'
import { paletteColors, palette } from './palette'
import { components } from './components'

const baseTheme = createTheme({
  components,
  palette,
})

export { baseTheme, paletteColors }
